module.exports = __webpack_public_path__ + "img/Ga.fce2b9a5.png";